import Image from 'next/image';
import Link from 'next/link';
import type { Job } from '@/api/cms/jobs/types';
import type { DefaultCmsDataResponse } from '@/api/cms/types';
import BriefcaseIcon from '@/public/static/icons/BriefcaseJobIcon.svg';
import LocationIcon from '@/public/static/icons/LocationJob.svg';
import TagStatus from '@/public/static/icons/TagStatusNewJob.svg';

type Props = {
  jobItem: DefaultCmsDataResponse<Job>;
  type: 'vertical' | 'horizontal';
  searchContext?: string;
};
const CardJob = ({ jobItem, type, searchContext }: Props) => {
  return (
    <Link href={`/job/${jobItem.attributes.slug}`}>
      <div
        className={`shadow-shadowJobCard hover:shadow-shadow4 relative mx-auto w-full rounded-[8px] bg-white p-[16px] hover:cursor-pointer  ${
          type === 'horizontal'
            ? 'desktop:h-[264px] h-auto max-w-[388px]'
            : 'max-w-full'
        }`}
      >
        <div className={`flex flex-col gap-[16px]`}>
          <p className="w-[calc(100%_-_40px)] text-[18px] font-semibold">
            {searchContext ? (
              jobItem.attributes.title.split(searchContext).map((part, index) =>
                index === 0 ? (
                  part
                ) : (
                  <span key={index}>
                    <mark>{searchContext}</mark>
                    {part}
                  </span>
                )
              )
            ) : (
              <>{jobItem.attributes.title}</>
            )}
          </p>
          <div
            className={`flex flex-wrap ${
              type === 'horizontal' ? 'desktop:flex-col flex-row' : ''
            } gap-[16px]`}
          >
            {jobItem.attributes.locations.data[0]?.attributes.name && (
              <div className="flex gap-[8px]">
                <>
                  <LocationIcon />
                  <p>{jobItem.attributes.locations.data[0]?.attributes.name}</p>
                </>
              </div>
            )}
            {jobItem.attributes.salary ||
            (jobItem.attributes.min_salary && jobItem.attributes.max_salary) ? (
              <div className="flex gap-[8px]">
                <>
                  <Image
                    src={'/static/images/cash-money.webp'}
                    width={24}
                    height={24}
                    alt="cash-icon"
                  />
                  <p>
                    {jobItem.attributes.min_salary &&
                    jobItem.attributes.max_salary
                      ? jobItem.attributes.min_salary +
                        '-' +
                        jobItem.attributes.max_salary
                      : jobItem.attributes.salary}
                  </p>
                </>
              </div>
            ) : (
              <></>
            )}
            {jobItem.attributes.job_categories.data[0]?.attributes.name && (
              <div className="flex gap-[8px]">
                <>
                  <BriefcaseIcon />
                  <p>
                    {jobItem.attributes.job_categories.data[0]?.attributes.name}
                  </p>
                </>
              </div>
            )}
          </div>
        </div>
        <div className="absolute top-0 right-0 ">
          {jobItem.attributes.is_hot ? (
            <Image
              src={'/static/icons/StatusJobHotIcon.svg'}
              width={56}
              height={56}
              alt="hot-tag"
            />
          ) : (
            <>{jobItem.attributes.is_new ? <TagStatus /> : <></>}</>
          )}
        </div>
      </div>
    </Link>
  );
};
export default CardJob;
